import { useEffect,  useState } from "react";
import { Grid } from "@mui/material";
import BreadCrumbComp from "../../../components/breadCrumb";
import LaddaButton from "../../../components/buttons/laddaButton";
import SimpleTable from "../../../components/tables/simpleTable";
import SimpleSelect from "../../../components/selects/simpleSelect";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { icons } from "../../../constants";
import { foreign_trade_import_registration_TABLE } from "../columns";
import ImportRegistrationCreateUpdateModal from "../modals/importRegistrationCreateUpdate";
import { months } from "../../../constants/selectData";
import "../styles.css";
import {
  callApiAsync,
  deleteImportRegistration,
  getExpiringImportRegistrations,
  getImportRegistrationTable,
  getImportRegistrationYears,
  getSuppliersForeignTrade,
  syncImportRegistrationStates
} from "../../../services/apiService";
import { getTooltipImportRegistrationExpiration } from "../foreignTradeUtils";
import { StyledTooltip } from "../../../components/toolltipComponent";
import ToastNotification from "../../../components/toastNotification";
import VerificationModal from "../../../components/modals/verificationModal";
// Fechas en tabla/modal: ver .muxi/development/conocimiento-migrado-cursor.md

export const foreign_trade_import_registration_DATA = [
  {
    id: 1,
    registration_number: "RI-2025-0001",
    brand: "GE Healthcare",
    brand_id: 1,
    start_date: "2021-06-07",
    end_date: "2026-01-07",
    attached_file: "/files/biomedicalEquipment/827.jpg"
  },
  {
    id: 2,
    registration_number: "RI-2025-0002",
    brand: "Philips",
    brand_id: 2,
    start_date: "2025-02-01",
    end_date: "2026-01-07"
  },
  {
    id: 3,
    registration_number: "RI-2025-0003",
    brand: "Siemens Healthineers",
    brand_id: 3,
    start_date: "2025-03-10",
    end_date: "2026-28-09"
  },
  {
    id: 4,
    registration_number: "RI-2025-0004",
    brand: "Mindray",
    brand_id: 4,
    start_date: "2025-14-05",
    end_date: "2025-12-02"
  },
  {
    id: 5,
    registration_number: "RI-2025-0005",
    brand: "Dräger",
    brand_id: 5,
    start_date: "2025-04-09",
    end_date: "2026-04-02"
  },
  {
    id: 6,
    registration_number: "RI-2025-0006",
    brand: "Medtronic",
    brand_id: 6,
    start_date: "2025-14-02",
    end_date: "2026-05-01"
  },
  {
    id: 7,
    registration_number: "RI-2025-0007",
    brand: "Nihon Kohden",
    brand_id: 7,
    start_date: "2025-14-09",
    end_date: "2026-02-14"
  },
  {
    id: 8,
    registration_number: "RI-2025-0008",
    brand: "Olympus",
    brand_id: 8,
    start_date: "2025-06-01",
    end_date: "2026-05-31"
  },
  {
    id: 9,
    registration_number: "RI-2025-0009",
    brand: "Baxter",
    brand_id: 9,
    start_date: "2025-14-25",
    end_date: "2026-03-24"
  },
  {
    id: 10,
    registration_number: "RI-2025-0010",
    brand: "Canon Medical",
    brand_id: 10,
    start_date: "2025-07-10",
    end_date: "2026-07-09"
  },
  {
    id: 11,
    registration_number: "RI-2025-0011",
    brand: "BD",
    brand_id: 11,
    start_date: "2025-01-28",
    end_date: "2026-28-01"
  },
  {
    id: 12,
    registration_number: "RI-2025-0012",
    brand: "Zimmer Biomet",
    brand_id: 12,
    start_date: "2025-08-05",
    end_date: "2026-28-04"
  }
];

const ImportRegistration = () => {
  const [openModal, setOpenModal] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [expirationData, setExpirationData] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  const [openTooltip, setOpenTooltip] = useState(false);
  const [filterSuppliers, setFilterSuppliers] = useState([]);
  const [yearsOptions, setYearsOptions] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [showToast, setShowToast] = useState(false);
  const [toastSeverity, setToastSeverity] = useState("info");
  const [toastSummary, setToastSummary] = useState("");
  const [appliedFilters, setAppliedFilters] = useState({
    supplier_id: undefined,
    year: undefined,
    month: undefined
  });
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);

  const navigate = useNavigate();
  const validationSchema = {};

  const { control, getValues, reset, setValue } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      supplier: "",
      month: "",
      year: ""
    }
  });

  const fetchTable = ({
    supplier_id,
    year,
    month,
    page: p = page,
    pageSize: ps = pageSize
  } = {}) => {
    const sid = supplier_id ?? null;
    const y = year ?? null;
    const m = month ?? null;
    callApiAsync(
      () => getImportRegistrationTable(p, sid, y, m),  
      (res) => {
        setTableData(res.items || []);
        setTotal(res.total || 0);
        setPage(res.page || p);
        setPageSize(res.pageSize || ps);
      }
    );
  };

  const handlePageChange = (nextPage, nextRows) => {
    const newPageSize = nextRows || pageSize;
    setPage(nextPage);
    setPageSize(newPageSize);
    fetchTable({ ...appliedFilters, page: nextPage, pageSize: newPageSize });
  };

  const handleFilter = () => {
    const { supplier, year, month } = getValues();
    const newFilters = {
      supplier_id: supplier || null,
      year: year || null,
      month: month || null
    };
    setAppliedFilters(newFilters);
    fetchTable({ ...newFilters, page: 1, pageSize });
  };

  const handleClearFilters = () => {
    reset({ supplier: "", year: "", month: "" });
    const cleared = {
      supplier_id: undefined,
      year: undefined,
      month: undefined
    };
    setAppliedFilters(cleared);
    setPage(1);
    fetchTable({ ...cleared, page: 1, pageSize });
  };

  const handlePageSizeChange = (nextSize) => {
    setPageSize(nextSize);
    setPage(1);
    fetchTable({ ...appliedFilters, page: 1, pageSize: nextSize });
  };

  const handleTooltipClose = () => {
    setOpenTooltip(false);
  };

  const handleTooltipOpen = () => {
    setOpenTooltip(true);
  };

  const handleOpenModal = (rowData) => {
    setSelectedRow(rowData);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedRow(null);
  };

  const handleDeleteRow = (row) => {
    setRowToDelete(row);
    setOpenDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setOpenDeleteModal(false);
    setRowToDelete(null);
  };

  const confirmDelete = async () => {
    if (!rowToDelete?.id) return;
    await callApiAsync(
      () => deleteImportRegistration(rowToDelete.id),
      () => {
        closeDeleteModal();
        fetchTable({ ...appliedFilters, page, pageSize });
        getExpiringImportRegistrationsData();
        onShowToast("success", "Registro de importación marcado como eliminado correctamente.");
      }
    );
  };

  const getTableData = () => {
    callApiAsync(
      () => getImportRegistrationTable(),
      (data) => {
        setTableData(data);
      }
    );
  };

  const getSelectSuppliers = () => {
    callApiAsync(
      () => getSuppliersForeignTrade(),
      (data) => {
        const list = Array.isArray(data) ? data : (data?.items ?? data?.data ?? []);
        const options = list.map((s) => ({
          name: s.name ?? s.label ?? String(s.value ?? s.id ?? ""),
          value: s.value != null ? s.value : s.id
        })).filter((o) => o.value != null && o.value !== "");
        setFilterSuppliers(options);
      }
    );
  };

  const getYearsData = () => {
    callApiAsync(
      () => getImportRegistrationYears(),
      (data) => {
        const list = Array.isArray(data) ? data : [];
        const options = list.map((y) => ({ name: String(y), value: y }));
        setYearsOptions(options);
      }
    );
  };

  const getExpiringImportRegistrationsData = () => {
    callApiAsync(
      () => getExpiringImportRegistrations(),
      (data) => {
        setExpirationData(data);
      }
    );
  };

  useEffect(() => {
    callApiAsync(() => syncImportRegistrationStates(), () => {});
    fetchTable({ page: 1, pageSize });
    getExpiringImportRegistrationsData();
    getSelectSuppliers();
    getYearsData();
  }, []);

  useEffect(() => {
    if (yearsOptions.length > 0 && (getValues("year") === "" || getValues("year") == null)) {
      setValue("year", yearsOptions[0].value);
    }
  }, [yearsOptions]);

  const onShowToast = (severity, summary) => {
    setToastSeverity(severity);
    setToastSummary(summary);
    setShowToast(true);
  };

  return (
    <div>
      <ToastNotification
        severity={toastSeverity}
        summary={toastSummary}
        showToast={showToast}
        setShowToast={setShowToast}
        zIndex={99999}
        position="top-right"
      />
      <BreadCrumbComp />

      <div className="searchTitle">
        <h1>REGISTRO DE IMPORTACIÓN</h1>
        <StyledTooltip
          title={getTooltipImportRegistrationExpiration(
            expirationData?.items,
            handleOpenModal,
            handleTooltipClose
          )}
          onClose={() => handleTooltipClose()}
          open={openTooltip}
          placement="bottom"
        >
          <div
            className="expired-notification pointer"
            onClick={() => handleTooltipOpen()}
          >
            <div className="HContainer align-center">
              <div className="red-notification-circle">
                {expirationData?.expiring_count}
              </div>
              <img
                className="btn-icon"
                src={icons.blackBell}
                alt="icon"
                style={{ marginRight: "10px" }}
              />
              <p className="button_text">Alerta Vigencia</p>
            </div>
          </div>
        </StyledTooltip>
      </div>
      <div className="table-container">
        <div className="HContainer j-space-between a-center">
          <h1
            className="title-bio-details-chard"
            style={{ display: "flex", alignItems: "center" }}
          >
            {`REGISTRO DE IMPORTACIÓN`}
          </h1>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <LaddaButton
              variant="contained"
              onClick={() => handleOpenModal(null)}
              margin={"0"}
            >
              <img className="btn-icon" src={icons.plusIcon} alt="icon" />
              <span style={{ marginLeft: "12px" }}>Agregar Registro</span>
            </LaddaButton>
          </div>
        </div>

        <div className="mb-15">
          <form className="mt-25">
            <Grid container spacing={1}>
              <Grid item xs={12} md={2}>
                <SimpleSelect
                  name="supplier"
                  control={control}
                  label="Proveedor"
                  options={filterSuppliers}
                  margin={"0"}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <SimpleSelect
                  name="month"
                  control={control}
                  label="Mes"
                  options={months}
                  margin={"0"}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <SimpleSelect
                  name="year"
                  control={control}
                  label="Año"
                  options={yearsOptions}
                  margin={"0"}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <div className={`IHContainer `}>
                  <LaddaButton
                    variant="contained"
                    onClick={handleFilter}
                    margin={"0"}
                  >
                    <img
                      className="btn-icon"
                      src={icons.filterWhite}
                      alt="icon"
                    />
                  </LaddaButton>
                  <LaddaButton
                    variant="contained"
                    onClick={handleClearFilters}
                    margin={"0 0 0 10px"}
                  >
                    <img
                      className="btn-icon"
                      src={icons.clearFilterWhite}
                      alt="icon"
                    />
                  </LaddaButton>
                </div>
              </Grid>
            </Grid>
          </form>
        </div>

        <SimpleTable
          data={tableData}
          columns={foreign_trade_import_registration_TABLE(
            navigate,
            handleOpenModal,
            handleDeleteRow
          )}
          text=""
          isPaginated={true}
          scrollHeight="1200px"
          totalRecords={total}
          currentPage={page}
          pageSize={pageSize}
          onPageChange={handlePageChange}
        />

        <ImportRegistrationCreateUpdateModal
          open={openModal}
          handleClose={handleCloseModal}
          row={selectedRow}
          onShowToast={onShowToast}
          getTable={() => {
            fetchTable({ ...appliedFilters, page, pageSize });
            getExpiringImportRegistrationsData();
          }}
        />

        <VerificationModal
          open={openDeleteModal}
          handleClose={closeDeleteModal}
          alertText={
            <>
              <b>¿Estás seguro de que deseas eliminar este registro de importación?</b>
              {rowToDelete && (
                <div style={{ marginTop: "10px", fontSize: "14px" }}>
                  <p>Nro. de Registro: {rowToDelete.registration_number}</p>
                  <p>Proveedor: {rowToDelete.supplier_name}</p>
                  <p>Producto: {rowToDelete.product}</p>
                </div>
              )}
            </>
          }
          onConfirm={confirmDelete}
          iconSeverity="danger"
          yesNo={true}
        />
      </div>
    </div>
  );
};

export default ImportRegistration;
